<template lang="pug">
  v-dialog(
    v-model="active"
    persistent
    width="400"
  )
    v-card(:loading="loading")
      v-card-title
        | New Campaign

      v-card-text
        v-layout(column)
          v-flex
            v-text-field(
              label="Sale Order"
              v-model="form.orderNo"
            )
          v-flex
            v-text-field(
              label="Client"
              v-model="form.client"
            )
          v-flex
            v-text-field(
              label="Strategy"
              v-model="form.strategy"
            )
          v-flex
            v-select(
              label="Market"
              :items="optMarkets"
              v-model="form.markets"
              multiple
            )
          v-flex
            v-select(
              label="Language"
              v-model="form.language"
              :items="optLanguages"
            )
          v-flex
            v-select(
              label="Match Type"
              v-model="form.match"
              :items="optMatchs"
            )

      v-card-actions.pa-3
        v-layout
          v-flex(xs6)
            v-btn(block color="green" @click="doSubmit") Submit
          v-flex(xs6)
            v-btn(block @click="active = false") Close
</template>

<script>
import ads from '@/services/googles/ads'

const OPT_MARKETS = [
  { text: 'Thailand', value: 'th' },
  { text: 'United Kingdom', value: 'gb' },
  { text: 'United States', value: 'us' },
  { text: 'Russia', value: 'ru' }
]
const OPT_LANGUAGES = [
  { text: 'Thai', value: 'th' },
  { text: 'English', value: 'en' }
]
const OPT_MATCHS = [
  { text: 'Exact', value: 'exact' },
  { text: 'BMM', value: 'bmm' }
]
const FORM_DEFAULT = {
  orderNo: '',
  client: '',
  strategy: '',
  markets: null,
  language: null,
  match: null
}

export default {
  props: {
    customerId: [String, Number],
    budgetId: [String, Number]
  },
  data () {
    return {
      active: false,
      loading: false,
      form: Object.assign({}, FORM_DEFAULT),
      headers: [
        { text: 'Strategy', value: 'strategy' },
        { text: 'Market', value: 'markets' },
        { text: 'Language', value: 'language.text' },
        { text: 'Match Type', value: 'match.text' }
      ],
      optMarkets: OPT_MARKETS,
      optLanguages: OPT_LANGUAGES,
      optMatchs: OPT_MATCHS
    }
  },
  mounted () {
  },
  methods: {
    show () {
      this.active = true
      this.loading = false
      this.form = Object.assign({}, FORM_DEFAULT)
    },
    hide () {
      this.active = false
    },
    getCampaignNames () {
      const data = this.form
      const markets = data.markets
      return markets.map(market => {
        const format = [data.orderNo, 'ppc', data.client, 'Campaing', data.strategy, market, data.language, data.match]
        return format.filter(n => n).join('-')
      })
    },
    doCreateCampaign (name) {
      const create = {
        name: name,
        advertising_channel_type: 'SEARCH',
        campaign_budget: `customers/${this.customerId}/campaignBudgets/${this.budgetId}`,
        manual_cpc: {
          enhanced_cpc_enabled: true
        }
      }
      return ads.addCampaign(this.customerId, create)
    },
    async doSubmit () {
      this.loading = true

      const names = this.getCampaignNames()
      const tasks = names.map(name => this.doCreateCampaign(name))
      await Promise.all(tasks)

      this.hide()
      this.$emit('complele', true)
    }
  }
}
</script>
